export const EVENTS = {
  PRE_MEETING_BRIEF_DOWNLOAD_CLICKED: "pre_meeting_brief_download_clicked",
  PRE_MEETING_BRIEF_SHARE_CLICKED: "pre_meeting_brief_share_clicked",
  PRE_MEETING_BRIEF_SHARE_MODAL_OPENED: "pre_meeting_brief_share_modal_opened",
  PRE_MEETING_BRIEF_EMAIL_RECIPIENT_SELECTED:
    "pre_meeting_brief_email_recipient_selected",
  PRE_MeETING_BRIEF_SHARE_EMAIL_SENT: "pre_meeting_brief_share_email_sent",
  PAGE_LOAD_EVENT: "pre_meeting_brief_page_viewed",
  ACCOUNT_SELECTION: "pre_meeting_brief_account_selected",
  PEOPLE_SEARCH: "pre_meeting_brief_person_search_initiated",
  SENIORITY_SEARCH: "pre_meeting_brief_person_seniority_initiated",
  LOCATION_SEARCH: "pre_meeting_brief_person_location_initiated",
  RESULT_GENERATED: "pre_meeting_brief_search_result_generated",
  PREVIOUS_BRIEFS_VIEWED: "pre_meeting_brief_previous_briefs_viewed",
  ERROR_EVENTS: "pre_meeting_brief_account_selection_error",
  PERSON_SEARCH_ERROR: "pre_meeting_brief_person_search_error",
  RESULT_GENERATION_ERROR: "pre_meeting_brief_search_result_generation_error",
  VIEW_PRE_MEETING_BRIEF_CLICKED: "pre_meeting_brief_generate_clicked",
  PAGINATION_CLICKED: "pre_meeting_brief_pagination_clicked",
  SELECT_ALL_CLICKED: "pre_meeting_brief_select_all_clicked",
  MULTIPLE_PEOPLE_SELECTED: "pre_meeting_brief_multiple_people_selected",
  SINGLE_PERSON_SELECTED: "pre_meeting_brief_single_people_selected",
  PREVIOUS_PRE_MEETING_BRIEF_USED:
    "pre_meeting_brief_previous_briefs_search_used",
  PREVIOUS_MEETING_BRIEF_OPENED: "pre_meeting_brief_previous_brief_opened",
  PAGINATION_CLICKED_PREVIOUS_BRIEFS_PAGE:
    "pre_meeting_brief_previous_briefs_pagination_clicked",
  PERSON_SELECTION_CHANGED: "pre_meeting_brief_person_selected",
  BRIEF_GENERATED: "pre_meeting_brief_generated",
  MESSAGE_TEMPLATE_CLICKED: "pre_meeting_brief_message_template_viewed",
  DOWNLOAD_CLICKED: "pre_meeting_brief_download_clicked",
  DOWNLOAD_PERSON_BRIEF: "download_person_brief",
  SHARE_CLICKED: "pre_meeting_brief_share_clicked",
  GET_EMAIL_CLICKED: "pre_meeting_brief_get_email_clicked",
  NEWS_CLICKED: "pre_meeting_brief_person_news_clicked",
  CLICK_OP_FROM_PRE_MEETING: "click_op_from_pre_meeting",
  PERSON_BRIEF_CLICKED: "person_brief_clicked",
  UPCOMING_MEETING_BRIEF_VIEWED: "upcoming_meeting_brief_viewed",
  SEARCH_FORM_SUBMITTED: "search_form_submitted",
  SEARCH_RESULTS_BRIEF_GENERATED: "search_results_brief_generated"
}
